import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TelecomService } from '../services/telecom.service';
export const telecomGuard:CanActivateFn=async route=>{
  const service=inject(TelecomService),router=inject(Router),access=await service.access();
  return (route.data['telecomAdmin']?access.admin:access.visible)||router.createUrlTree(['/welcome']);
};
